export default "__VITE_ASSET__CYdrgQ6e__"